import { gql } from '@apollo/client'

import { FRAGMENT_TERRITORY_PERFORMANCE_TOTAL_METRICS } from './fragments'

export const GET_TERRITORY_PERFORMANCE_TOTAL_METRICS_QUERY = gql`
  query getTerritoryPerformanceTotalMetrics($territoryId: ID!, $timeRange: TimeRange!, $providers: [Providers!]) {
    getTerritory(territoryId: $territoryId) {
      territoryPerformance {
        ...FragmentTerritoryPerformanceTotalMetrics
      }
    }
  }
  ${FRAGMENT_TERRITORY_PERFORMANCE_TOTAL_METRICS}
`

export const GET_PAGINATED_TRENDING_TAGS_QUERY = gql`
  query getPaginatedTrendingTags(
    $filters: TrendingSubjectFiltersInput!
    $providers: [Providers!]
    $pagination: TerritoryPostsPagination!
    $timeRange: TimeRange
    $postLimit: Int! = 1
    $withPost: Boolean! = false
    $withTopics: Boolean! = false
    $withTerritoryPerformance: Boolean! = false
  ) {
    listTrendingSubjectPaginated(filters: $filters, pagination: $pagination) {
      total
      cursor
      data {
        language
        name
        provider
        territoryId
        sortIndex
        topics @include(if: $withTopics) {
          createdAt
          title
        }
        territoryPerformance @include(if: $withTerritoryPerformance) {
          ...FragmentTerritoryPerformanceTotalMetrics
        }
        territoryMostEngaged @include(if: $withPost) {
          posts(limit: $postLimit) {
            thumbnail
            postId
            provider
            description
            title
          }
        }
      }
    }
  }
  ${FRAGMENT_TERRITORY_PERFORMANCE_TOTAL_METRICS}
`
export const GET_TERRITORIES_TRENDING_ALERT = gql`
  query getTerritoryTrendingAlert($territoryId: ID!) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      territoryTrending {
        lastDateTimeAsTrending
      }
    }
  }
`
